import {Component} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-map-detail',
  templateUrl: './map-detail.component.html'
})
export class MapDetailComponent extends BaseComponent {
  map:any;
  alarmFilters:any[];
  diagrams:any[];

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/geo/maps/${id}`).subscribe(
            data => {
              this.map = data as any;
            }
          );
        }
      });
  }

  createNew() {
    this.map = {
      alarmFilters: [],
      diagrams: [],
      cycleInterval: 10000
    };
  }

  save() {
    if (!this.map.id) {
      this.http.post(`${this.env.e.url}/geo/maps`, this.map)
        .subscribe(
          data => {
            this.map = data;
            this.alertService.info(`Created ${this.map.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/geo/maps/${this.map.id}`, this.map)
        .subscribe(
          data => {
            this.map = data;
            this.alertService.info(`Updated Map Settings`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/geo/map/${this.map.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted Map ${this.map.name}`);
          this.router.navigate(["/maps"]);
        }
      );
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }
}
